 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~authentication-authentication-module~pages-ViewElectronicRemittance-ViewElectronicRemittance~f258f374":"default~authentication-authentication-module~pages-ViewElectronicRemittance-ViewElectronicRemittance~f258f374","authentication-authentication-module":"authentication-authentication-module","common":"common","pages-payment-payment-module":"pages-payment-payment-module","default~appointment-appointment-module~officehours-officehours-module~pages-ViewElectronicRemittance~20aa0139":"default~appointment-appointment-module~officehours-officehours-module~pages-ViewElectronicRemittance~20aa0139","pages-custom-calendar-custom-calendar-module":"pages-custom-calendar-custom-calendar-module","default~appointmentsummary-appointment-summary-module~insuranceaging-insurance-aging-module~insuranc~9105afe3":"default~appointmentsummary-appointment-summary-module~insuranceaging-insurance-aging-module~insuranc~9105afe3","pages-calendarsettings-calendarsettings-module":"pages-calendarsettings-calendarsettings-module","pages-masters-masters-module":"pages-masters-masters-module","pages-provider-dashboard-provider-dashboard-module":"pages-provider-dashboard-provider-dashboard-module","default~appointment-appointment-module~pages-evaluation-patientevalution-module~pages-patient-dashbo~a8387606":"default~appointment-appointment-module~pages-evaluation-patientevalution-module~pages-patient-dashbo~a8387606","default~appointment-appointment-module~officehours-officehours-module~pages-patient-dashboard-patien~dcd50d45":"default~appointment-appointment-module~officehours-officehours-module~pages-patient-dashboard-patien~dcd50d45","default~pages-evaluation-patientevalution-module~pages-evaluationpocpreview-evaluationpocpreview-mod~8f247fbd":"default~pages-evaluation-patientevalution-module~pages-evaluationpocpreview-evaluationpocpreview-mod~8f247fbd","default~pages-claimdashboard-claimdashboard-module~pages-patient-dashboard-patient-dashboard-module~~cb12e668":"default~pages-claimdashboard-claimdashboard-module~pages-patient-dashboard-patient-dashboard-module~~cb12e668","default~pages-patient-dashboard-patient-dashboard-module~pages-patientfacesheet-patient-facesheet-mo~5fad19a9":"default~pages-patient-dashboard-patient-dashboard-module~pages-patientfacesheet-patient-facesheet-mo~5fad19a9","default~pages-patient-dashboard-patient-dashboard-module~pages-patientfacesheet-patient-facesheet-mo~7efc908d":"default~pages-patient-dashboard-patient-dashboard-module~pages-patientfacesheet-patient-facesheet-mo~7efc908d","default~pages-patient-dashboard-patient-dashboard-module~pages-patientfacesheet-patient-facesheet-mo~d9de7517":"default~pages-patient-dashboard-patient-dashboard-module~pages-patientfacesheet-patient-facesheet-mo~d9de7517","default~pages-patientfacesheet-patient-facesheet-module~patientstatement-patientstatement-module":"default~pages-patientfacesheet-patient-facesheet-module~patientstatement-patientstatement-module","pages-patient-dashboard-patient-dashboard-module":"pages-patient-dashboard-patient-dashboard-module","default~pages-userprofile-user-profile-module~patient-sub-module~provider-provider-module~public-pat~2ff5a542":"default~pages-userprofile-user-profile-module~patient-sub-module~provider-provider-module~public-pat~2ff5a542","default~appointment-appointment-module~officehours-officehours-module~patient-sub-module~public-pati~98803da6":"default~appointment-appointment-module~officehours-officehours-module~patient-sub-module~public-pati~98803da6","default~patient-sub-module~public-patient-public-patient-module":"default~patient-sub-module~public-patient-public-patient-module","public-patient-public-patient-module":"public-patient-public-patient-module","default~pages-ViewElectronicRemittance-ViewElectronicRemittance-module~pages-ViewElectronicRemittanc~0e189830":"default~pages-ViewElectronicRemittance-ViewElectronicRemittance-module~pages-ViewElectronicRemittanc~0e189830","pages-ViewElectronicRemittance-carddashboard-ERADashboard-module":"pages-ViewElectronicRemittance-carddashboard-ERADashboard-module","pages-staleera-carddashboard-staleeraDashboard-module":"pages-staleera-carddashboard-staleeraDashboard-module","default~pages-claimdashboard-claimdashboard-module~pages-clearingreportdashboard-clearingreportdashb~c32d151a":"default~pages-claimdashboard-claimdashboard-module~pages-clearingreportdashboard-clearingreportdashb~c32d151a","default~pages-claimdashboard-claimdashboard-module~pages-reconciliationdashboard-reconciliationdashb~dd9f610c":"default~pages-claimdashboard-claimdashboard-module~pages-reconciliationdashboard-reconciliationdashb~dd9f610c","pages-claimdashboard-claimdashboard-module":"pages-claimdashboard-claimdashboard-module","pages-reconciliationdashboard-reconciliationdashboard-module":"pages-reconciliationdashboard-reconciliationdashboard-module","default~pages-evaluation-patientevalution-module~pages-evaluationpocpreview-evaluationpocpreview-module":"default~pages-evaluation-patientevalution-module~pages-evaluationpocpreview-evaluationpocpreview-module","pages-evaluation-patientevalution-module":"pages-evaluation-patientevalution-module","pages-patient-patient-main-module":"pages-patient-patient-main-module","pages-clearingreportdashboard-clearingreportdashboard-module":"pages-clearingreportdashboard-clearingreportdashboard-module","default~pages-encounterform-encounterform-module~pages-superbill-superbill-module":"default~pages-encounterform-encounterform-module~pages-superbill-superbill-module","pages-encounterform-encounterform-module":"pages-encounterform-encounterform-module","pages-evaluationpocpreview-evaluationpocpreview-module":"pages-evaluationpocpreview-evaluationpocpreview-module","default~pages-poctemplate-createedit-poctemplate-module~poc-poc-module":"default~pages-poctemplate-createedit-poctemplate-module~poc-poc-module","pages-poctemplate-createedit-poctemplate-module":"pages-poctemplate-createedit-poctemplate-module","pages-userprofile-user-profile-module":"pages-userprofile-user-profile-module","pages-appointmentpoc-createedit-appointmentpoc-module":"pages-appointmentpoc-createedit-appointmentpoc-module","pages-appointments-appointments-module":"pages-appointments-appointments-module","pages-ViewElectronicRemittance-ViewElectronicRemittance-module":"pages-ViewElectronicRemittance-ViewElectronicRemittance-module","pages-staleera-staleera-module":"pages-staleera-staleera-module","pages-clinicalnotes-clinicalnotes-module":"pages-clinicalnotes-clinicalnotes-module","pages-superbill-superbill-module":"pages-superbill-superbill-module","pages-stripe-integration-stripe-integration-module":"pages-stripe-integration-stripe-integration-module","pages-report-report-module":"pages-report-report-module","pages-voicerrecognition-voicerecognition-module":"pages-voicerrecognition-voicerecognition-module","apply-era-apply-era-module":"apply-era-apply-era-module","apply-selfpay-apply-selfpay-module":"apply-selfpay-apply-selfpay-module","era-payment-era-payment-module":"era-payment-era-payment-module","patient-payment-patient-payment-module":"patient-payment-patient-payment-module","holiday-holiday-module":"holiday-holiday-module","settings-settings-module":"settings-settings-module","timeoffevent-timeoffevent-module":"timeoffevent-timeoffevent-module","officehours-officehours-module":"officehours-officehours-module","equipment-equipment-module":"equipment-equipment-module","room-room-module":"room-room-module","visitreason-visitreason-module":"visitreason-visitreason-module","appointmentdeadline-appointmentdeadline-module":"appointmentdeadline-appointmentdeadline-module","assessmenttool-assessmenttool-module":"assessmenttool-assessmenttool-module","referringprovider-referring-provider-module":"referringprovider-referring-provider-module","poc-poc-module":"poc-poc-module","provider-provider-module":"provider-provider-module","user-user-module":"user-user-module","domain-domain-module":"domain-domain-module","insurancepayer-insurancepayer-module":"insurancepayer-insurancepayer-module","providertype-provider-type-module":"providertype-provider-type-module","reportparameter-reportparameter-module":"reportparameter-reportparameter-module","screenactivity-screenactivity-module":"screenactivity-screenactivity-module","servicelocation-service-location-module":"servicelocation-service-location-module","speciality-speciality-module":"speciality-speciality-module","subdomain-subdomain-module":"subdomain-subdomain-module","toolconfiguration-toolconfiguration-module":"toolconfiguration-toolconfiguration-module","patient-sub-module":"patient-sub-module","appointment-appointment-module":"appointment-appointment-module","patient-patient-module":"patient-patient-module","Insurance-insurance-module":"Insurance-insurance-module","selfpay-self-pay-module":"selfpay-self-pay-module","paymentreport-paymentreport-module":"paymentreport-paymentreport-module","appointmentsummary-appointment-summary-module":"appointmentsummary-appointment-summary-module","patientstatement-patientstatement-module":"patientstatement-patientstatement-module","insuranceaging-insurance-aging-module":"insuranceaging-insurance-aging-module","insurancepayment-insurance-payment-module":"insurancepayment-insurance-payment-module","missedencounters-missed-encounters-module":"missedencounters-missed-encounters-module","download-download-module":"download-download-module","patientcontact-patient-contact-module":"patientcontact-patient-contact-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
